export default function Shower() {
  const pathStyle = {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    isCustomFont: 'none',
    fontFileUrl: 'none',
    fill: 'rgb(255, 255, 255)',
    opacity: 1,
  };
  return (
    <svg version="1.0" className="w-8 h-8" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path style={pathStyle} d="M2230 4434 c-14 -2 -59 -9 -100 -15 -231 -34 -489 -173 -657 -353
-183 -196 -288 -434 -313 -710 -8 -82 -10 -515 -8 -1351 l3 -1230 22 -40 c42
-79 108 -119 198 -119 75 -1 136 31 180 92 l30 44 5 1306 c6 1296 6 1308 27
1382 29 101 54 158 104 233 187 276 541 393 851 280 218 -78 390 -258 457
-476 22 -72 21 -87 -6 -87 -9 0 -54 -18 -101 -41 -103 -50 -211 -151 -265
-249 -37 -67 -77 -185 -77 -225 0 -17 -9 -26 -32 -34 -118 -41 -182 -192 -129
-306 10 -22 34 -54 52 -72 70 -66 34 -63 831 -63 815 0 769 -4 839 79 100 116
64 291 -71 353 -41 19 -50 27 -50 49 0 94 -80 250 -180 350 -83 84 -193 147
-295 170 -47 10 -55 16 -55 34 0 41 -48 209 -83 290 -153 355 -468 611 -849
689 -77 16 -281 28 -328 20z m306 -158 c366 -77 667 -349 777 -701 13 -44 28
-97 31 -118 l7 -38 -82 3 -82 3 -14 59 c-17 76 -81 212 -137 289 -50 70 -149
168 -216 214 -248 168 -582 195 -856 68 -102 -47 -185 -107 -271 -198 -135
-142 -215 -322 -233 -521 -5 -56 -9 -650 -10 -1322 0 -1167 -1 -1222 -18
-1237 -33 -30 -75 -32 -108 -4 l-29 25 0 1289 c0 1431 -4 1352 68 1541 132
353 455 609 832 661 88 12 250 6 341 -13z m967 -1011 c94 -20 175 -66 247
-141 62 -64 112 -154 125 -227 l7 -37 -582 0 -582 0 7 33 c12 53 44 127 75
172 67 97 195 182 305 203 79 15 321 14 398 -3z m533 -578 c31 -37 31 -78 -2
-116 l-26 -31 -706 0 c-540 1 -711 4 -723 13 -56 43 -48 132 15 157 11 5 335
8 719 7 l699 -2 24 -28z"/>
<path style={pathStyle} d="M2856 2168 c-12 -17 -16 -48 -16 -119 0 -93 1 -98 26 -118 35 -27 59
-26 89 4 23 22 25 32 25 120 0 82 -3 98 -20 115 -28 28 -84 27 -104 -2z"/>
<path style={pathStyle} d="M3276 2168 c-12 -17 -16 -48 -16 -119 0 -93 1 -98 26 -118 35 -27 59
-26 89 4 23 22 25 32 25 120 0 82 -3 98 -20 115 -28 28 -84 27 -104 -2z"/>
<path style={pathStyle} d="M3696 2168 c-12 -17 -16 -48 -16 -119 0 -93 1 -98 26 -118 35 -27 59
-26 89 4 23 22 25 32 25 120 0 82 -3 98 -20 115 -28 28 -84 27 -104 -2z"/>
<path style={pathStyle} d="M2620 1700 c-17 -17 -20 -33 -20 -115 0 -88 2 -98 25 -120 30 -30 54
-31 89 -4 25 20 26 25 26 118 0 115 -12 141 -66 141 -21 0 -42 -8 -54 -20z"/>
<path style={pathStyle} d="M3040 1700 c-17 -17 -20 -33 -20 -115 0 -88 2 -98 25 -120 30 -30 54
-31 89 -4 25 20 26 25 26 118 0 115 -12 141 -66 141 -21 0 -42 -8 -54 -20z"/>
<path style={pathStyle} d="M3460 1700 c-17 -17 -20 -33 -20 -115 0 -88 2 -98 25 -120 30 -30 54
-31 89 -4 25 20 26 25 26 118 0 115 -12 141 -66 141 -21 0 -42 -8 -54 -20z"/>
<path style={pathStyle} d="M3880 1700 c-17 -17 -20 -33 -20 -115 0 -88 2 -98 25 -120 30 -30 54
-31 89 -4 25 20 26 25 26 118 0 115 -12 141 -66 141 -21 0 -42 -8 -54 -20z"/>
</g>
</svg>

  );
}
